import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { isVaultOperativeScopeHydrated } from '../vault-operative-role.util';
import { VaultMenuAccessService } from './vault-menu-access.service';
import { normalizeVaultMenuRouteKey } from './vault-menu-canonical.snapshot';
import {
  getQaFallbackAllowedRouteKeys,
  resolveVaultQaRoleProfileForRestrictions,
  userIsSuperadminFromSession,
} from './vault-role-menu-matrix.util';
import {
  isRouteKeyAllowedStrict,
  vaultSidebarPermissionsReady,
} from './vault-sidebar-menu-merge.util';

const VAULT_LAYOUT_PREFIX = '/layout/vault';

export const vaultModuleAccessGuard: CanActivateChildFn = (_childRoute, state) => {
  const menuAccess = inject(VaultMenuAccessService);
  const router = inject(Router);

  const url = state.url.split('?')[0].split('#')[0];
  if (!url.includes(VAULT_LAYOUT_PREFIX)) {
    return true;
  }

  const key = normalizeVaultMenuRouteKey(url);
  if (
    !key ||
    key === normalizeVaultMenuRouteKey('/layout/vault/dashboard') ||
    key === normalizeVaultMenuRouteKey('/layout/vault/access-denied')
  ) {
    return true;
  }

  if (userIsSuperadminFromSession()) {
    return true;
  }

  if (!vaultSidebarPermissionsReady() && isVaultOperativeScopeHydrated()) {
    const profile = resolveVaultQaRoleProfileForRestrictions();
    if (profile !== 'unknown' && profile !== 'admin') {
      const fallback = getQaFallbackAllowedRouteKeys(profile);
      if (!isRouteKeyAllowedStrict(key, fallback)) {
        const label = menuAccess.getLabelForRoute(url);
        return router.createUrlTree(['/layout/vault/access-denied'], {
          queryParams: { label, from: url },
        });
      }
    }
    return true;
  }

  if (!vaultSidebarPermissionsReady()) {
    return true;
  }

  if (!menuAccess.shouldBlockAccess(url)) {
    return true;
  }

  const label = menuAccess.getLabelForRoute(url);
  return router.createUrlTree(['/layout/vault/access-denied'], {
    queryParams: { label, from: url },
  });
};
